import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { landingData } from "../data";
import ServiceCard from "../components/ServiceCard";
import { ChevronDown } from "lucide-react";

const Services = ({ animations, isMobile }) => {
  return (
    <section
      className="relative py-16 md:py-32 min-h-screen bg-cover bg-center"
      style={{
        backgroundImage: "url('images/landing/bg.png')",
        backgroundAttachment: isMobile ? "scroll" : "fixed",
        boxShadow: isMobile
          ? "0 20px 5px -10px rgba(0,0,0,0.2) inset, 0 -15px 5px -10px rgba(0,0,0,0.3) inset"
          : "0 40px 10px -20px rgba(0,0,0,0.3) inset, 0 -30px 10px -20px rgba(0,0,0,0.45) inset",
      }}
    >
      <div className={`${styles.overlay} bg-black/50`} />
      <div className={`relative ${styles.container}`}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.4 }}
          className={`${styles.sectionTitle} text-white text-center mb-8 md:mb-16`}
        >
          Our Industries Served
        </motion.h2>

        {/* Desktop Version */}
        <div className="hidden md:block">
          <div className="relative">
            <div className="absolute left-1/2 h-full border-l-2 border-white border-dashed" />
            <div className="space-y-24 md:space-y-32">
              {landingData.services.map((service) => (
                <ServiceCard
                  key={service.id}
                  service={service}
                  isEven={service.id % 2 === 0}
                  animations={animations}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Mobile Version */}
        <div className="md:hidden">
          <div className="relative">
            <div className="absolute left-4 top-0 bottom-0 w-0.5 border-l-2 border-white border-dashed" />
            <div className="space-y-16">
              {landingData.services.map((service) => (
                <motion.div
                  key={service.id}
                  initial="initial"
                  whileInView="animate"
                  viewport={{ once: true, amount: 0.2, margin: "-50px" }}
                  className="pl-8 relative"
                >
                  <motion.div
                    className="absolute left-0 mt-4 w-10 h-10 rounded-full bg-white flex items-center justify-center text-primary text-lg font-bold -translate-x-1/2"
                    variants={animations.scaleIn}
                  >
                    {service.id}
                  </motion.div>
                  <motion.div
                    className="bg-white/10 backdrop-blur ml-2 p-4 rounded-lg text-white"
                    variants={animations.slideInFromRight}
                  >
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full rounded-lg mb-4"
                      loading="lazy"
                    />
                    <h3 className="text-lg font-bold mb-3 leading-tight">
                      {service.title}
                    </h3>
                    <p className="text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </motion.div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        {/* All Services Link */}
        <div className="mt-16 md:mt-24 text-center">
          <a href="/service">
            <span className="font-barlow-medium text-xl md:text-2xl text-white hover:text-white/80 transition-colors duration-300 inline-flex items-center gap-2">
              All Services
              <ChevronDown className="w-5 h-5" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
